/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LeadTypesResponseApiModel } from '../../models/lead-types-response-api-model';

export interface LeadTypes$Params {
}

export function leadTypes(http: HttpClient, rootUrl: string, params?: LeadTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<LeadTypesResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, leadTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LeadTypesResponseApiModel>;
    })
  );
}

leadTypes.PATH = '/leads/types';
